
import FranceMap from "~/assets/svg/france.svg?inline";

export default {
    components: {
        FranceMap,
    },
    data() {
        return {
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            zoom: 10,
            center: [0, 0],
            geoJsonData: null,
            fillColor: "#041e42",
            prefix: ' © <a href="https://leafletjs.com" title="A JavaScript library for interactive maps">Leaflet</a> | Contributeurs <a target="_blank" href="https://osm.org/copyright">OpenStreetMap</a>'
        };
    },
    computed: {
        getGeoJsonStyle() {
            const fillColor = this.fillColor;
            return () => {
                return {
                    weight: 3,
                    color: "#ce1141",
                    opacity: 1,
                    fillColor: fillColor,
                    fillOpacity: 0.2
                }
            }
        }
    },
    props: {
        latitude: {
            default: 0,
            type: Number
        },
        longitude: {
            default: 0,
            type: Number
        },
        slug: String,
        selected: {
            default: '',
            type: String
        },
        type: {
            default: 'city',
            type: String
        }
    },
    async created() {
        this.center = [this.latitude, this.longitude];
        const slugMapping = {
            'city': 'cities',
            'region': 'regions',
            'epci': 'intercommunalites',
        };

        const slugApi = slugMapping[this.type];

        const response = await fetch(this.$config.baseApiURL + '/' + slugApi + '/' + this.slug + '/geojson');
        this.geoJsonData = await response.json();
    },
    updated() {
        this.$nextTick(function () {
            try {
                this.$refs.mapControl.mapObject.fitBounds(this.$refs.geoLayer.getBounds(), { padding: [10, 10] });
                let paths = this.$el.querySelectorAll('path');
                paths.forEach(el => {
                    if (el.id == this.selected) {
                        el.classList.add("selected");
                    }
                });
            }
            catch (e) {
                // Nothing
            }
        })
    }
};
